// components/Layout.jsx
import React, { useState, useEffect, useRef } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = localStorage.getItem('sidebarOpen');
    return stored === 'true';
  });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    document.body.classList.add('no-body-scroll');
    return () => {
      document.body.classList.remove('no-body-scroll');
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      localStorage.setItem('sidebarOpen', !prev);
      return !prev;
    });
  };

  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(80);
  const FOOTER_BUFFER = 8;

  useEffect(() => {
    const updateFooterHeight = () => {
      const h = footerRef.current ? footerRef.current.offsetHeight : 80;
      setFooterHeight(h);
    };

    updateFooterHeight();

    let ro;
    if (typeof ResizeObserver !== 'undefined' && footerRef.current) {
      ro = new ResizeObserver(entries => {
        for (let entry of entries) {
          const h = entry.contentRect ? Math.ceil(entry.contentRect.height) : (footerRef.current ? footerRef.current.offsetHeight : 80);
          setFooterHeight(h);
        }
      });
      ro.observe(footerRef.current);
    } else {
      window.addEventListener('resize', updateFooterHeight);
    }

    return () => {
      if (ro && ro.disconnect) ro.disconnect();
      else window.removeEventListener('resize', updateFooterHeight);
    };
  }, []);

  return (
    <div
      className="layout-container"
      style={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh' 
      }}
    >
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div
        className="full-screen-div"
        style={{
          backgroundImage: `url('/assets/desktop.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: '53px',
          paddingBottom: '0px',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          marginLeft: isMobile ? '0' : isSidebarOpen ? '220px' : '70px',
          transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          flex: '1 1 auto',
        }}
      >
        <div
          className="content-container"
          style={{
            flex: '1 1 auto',
            paddingTop: '15px',
            paddingBottom: `${footerHeight + FOOTER_BUFFER}px`,
            paddingLeft: '15px',
            paddingRight: '15px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            minHeight: 0,
            transition: 'padding-left 0.3s ease-in-out',
          }}
        >
          {children}
        </div>
        <div ref={footerRef}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
